module.exports = __webpack_public_path__ + "static/header-bannerbg-ironcapapi-9244f691dbeb4845640d26d852357594.png";